module.exports = __webpack_public_path__ + "assets/img/points_1.03d053f6.svg";